//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [parseTextMixin],
  props: {
    largeTitle: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: ''
    },

    subtitle: {
      type: String,
      default: ''
    },

    fullWidth: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      return {
        Standfirst: true,
        'Standfirst--full-width': this.fullWidth
      }
    }
  }
}
